import React, { createContext, useCallback, useState, useContext } from "react";
import { useProgress } from "../hooks/progress";
//import errorIcon from '../components/Toast/Image/error.svg';
import check from "../components/Toast/Image/check.svg";
import error from "../components/Toast/Image/error.svg";
import Toast from "../components/Toast/ToastGG";
import api from "../services/api/index";
import { writeStorage } from "../utils/storage/storage";
import version from "../../package.json";

interface ISetRepresentante {
  id: any;
  tipo: any;
  formato: any;
}

interface ISignInCredentials {
  email: string;
  senha: string;
}

interface IAuthState {
  token: string;
}

interface IAuthContextData {
  setDados(credentials: ISetRepresentante): Promise<void>;
  isLogin: () => boolean;
  signIn(credentials: ISignInCredentials): Promise<void>;
  checkVersion(): void;
  setIsOpenUser(value: boolean): void;
  setIsOpenCompromisso(value: boolean): void;
  setIsEditing(value: boolean): void;
  setDataUser(data: any): void;
  setIsOpenCancel(value: boolean): void;
  handleActive(value: string): void;
  handleNewActive(value: string): void;
  setOpenModal(value: boolean): void;
  setOpenModalWpp(value: boolean): void;
  setChaveSessao(value: any): void;
  setEmailSessao(value: any): void;
  handleClickPage(value: string): void;
  openModalWpp: boolean;
  openModal: boolean;
  chaveSessao: boolean;
  emailSessao: boolean;
  active: string;
  newActive: string;
  dataUser: any;
  isOpenUser: boolean;
  isOpenCompromisso: boolean;
  isEditing: boolean;
  modalIsOpenCancel: boolean;
  headerLabel: string;
}

const AuthContext = createContext<IAuthContextData>({} as IAuthContextData);

const AuthProvider: React.FC = ({ children }) => {
  const [list, setList] = useState<any>([]);
  const [isOpenUser, setIsOpenUser] = useState<boolean>(false);
  const [isOpenCompromisso, setIsOpenCompromisso] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [dataUser, setDataUser] = useState();
  const [modalIsOpenCancel, setIsOpenCancel] = useState<boolean>(false);
  const [active, handleActive] = useState("default");
  const [newActive, handleNewActive] = useState("default");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalWpp, setOpenModalWpp] = useState<boolean>(false);
  const [chaveSessao, setChaveSessao] = useState<any>();
  const [emailSessao, setEmailSessao] = useState<any>();
  const [headerLabel, setHeaderLabel] = useState<string>("");

  let toastProperties: {
    id: number;
    title: string;
    description: string;
    backgroundColor: string;
    icon: any;
  } | null = null;
  //eslint-disable-next-line
  const showToast = (type: any) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "",
          description: "Login efetuado com sucesso",
          backgroundColor: "#5cb85c",
          icon: check,
        };
        break;
      case "primeiro":
        toastProperties = {
          id,
          title: "",
          description: "Primeiro acesso?",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "warning":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao efetuar login",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "email":
        toastProperties = {
          id,
          title: "",
          description: "Usuário inexistente",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "senhaErrada":
        toastProperties = {
          id,
          title: "",
          description: "Senha incorreta",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "cadastre":
        toastProperties = {
          id,
          title: "",
          description: "Cadastre sua senha...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "semEquipe":
        toastProperties = {
          id,
          title: "",
          description: "Coordenador sem equipe vinculada",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "redirect":
        toastProperties = {
          id,
          title: "",
          description: "Redirecionando...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "404":
        toastProperties = {
          id,
          title: "",
          description: "Sem propostas encontradas",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "403":
        toastProperties = {
          id,
          title: "",
          description: "Acesso não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "inativo":
        toastProperties = {
          id,
          title: "",
          description: "Login não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
        case "semCell":
          toastProperties = {
            id,
            title: "",
            description: "Sem WhatsApp cadastrado",
            backgroundColor: "#f0ad4e",
            icon: error,
          };
          break;
        case "falhouWhats":
            toastProperties = {
              id,
              title: "",
              description: "Erro ao enviar WhatsApp",
              backgroundColor: "#f0ad4e",
              icon: error,
            };
            break;
      default:
        setList([]);
    }
    setList([...list, toastProperties]);
  };

  const { setLoad } = useProgress();
  const [data, setData] = useState<IAuthState>(() => {
    const token = sessionStorage.getItem("@ARP-Energia:token");

    if (token) {
      return { token };
    }

    return {} as IAuthState;
  });

  const isLogin = useCallback(() => {
    return !!data.token;
  }, [data]);

  const dataSend = useCallback((id) => ({ id }), []);

  const setDadosLogin = useCallback(
    async ({ id, tipo, formato }) => {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      setLoad(true);
      await api.get(`/csp/representante/cards/consultar?idCard=${id}`)
        .then((res) => {
          const removeItem = (arr: any, refId: any) => {
            return arr.filter(function (i: any) {
              return i.situa_o_arp !== refId;
            });
          };
          const arr = removeItem(res.data["cards"], "inativo");
          if (res.status === 200) {
            setLoad(false);
            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });

            showToast("success");
            setTimeout(function () {
              showToast("redirect");
            }, 1000);

            setTimeout(function () {
              setLoad(false);
              window.location.href = "/arp/";
            }, 3000);
          }
        })
        .catch((error) => {
          setLoad(false);
          if (error.response.status === 403) {
            //showToast('403')
            setLoad(false);
          }
          if (error.response.status === 404) {
            const arr = error.response.data["cards"];

            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });

            showToast("success");
            setTimeout(function () {
              showToast("redirect");
            }, 1000);

            setTimeout(function () {
              setLoad(false);
              window.location.href = "/arp/";
            }, 3000);
          }
          if (error.response.status === 500) {
            //showToast('500')
            setLoad(false);
          }
        });
    },
    [setLoad, showToast]
  );

  const signIn = useCallback(
    async ({ email, senha }) => {
      localStorage.setItem("@ARP:notifications-after-login", "false");

      setLoad(true);
      await api
        .post("/csp/representante/login/", {
          email: email,
          senha: senha,
        })
        .then((res: any) => {
          writeStorage({
            key: "paginacao",
            object: {
              pageIndex: 0,
              pageSize: 10,
            },
          });

          if (res.status === 203) {
            setEmailSessao(email);
            setChaveSessao(res.data.chaveVerificaSessao);
            setOpenModal(true);
            setLoad(false);
          }
          if (res.status === 202) {
            setLoad(false);
            setTimeout(function () {
              showToast("primeiro");
            }, 1000);

            setTimeout(function () {
              setLoad(false);
              showToast("cadastre");
              setLoad(false);
              writeStorage({
                key: "login",
                object: {
                  idCard: res.data["retorno"],
                },
              });
            }, 3000);

            setTimeout(function () {
              window.location.href = "/arp/success/";
            }, 4000);
          }
          if (res.data["retorno"] === "OK") {
            const token = res.data.acessToken;
            sessionStorage.setItem("@ARP-Energia:token", token);
            setData({ token });

            writeStorage({
              key: "login",
              object: {
                NomeRepresentante: res.data.informacao["nome"],
                EmailRepresentante: res.data.informacao["e_mail"],
                CpfRepresentante: res.data.informacao["cpf"],
                RazaoRepresentante: res.data.informacao["raz_o_social"],
                CnpjRepresentante: res.data.informacao["cnpj"],
                TipoVendedor: res.data.informacao["tipo"],
                CodigoLink:
                  res.data.informacao["c_digo_do_link_verificar_com_a_bplus"],
                canal: res.data.informacao["canal"],
                Meta: res.data.informacao["meta_do_m_s_1"],
                Grupo: res.data.informacao["grupo"],
                Gestor1: res.data.informacao["gerente_respons_vel"],
                Gestor2:
                  res.data.informacao["executivo_supervisor_respons_vel"],
                Gestor3: res.data.informacao["gestor_3"],
                Origem: res.data.informacao["origem"],
                CodigoPlano: res.data.informacao["plano_que_est_vendendo"],
                Equipe: res.data.informacao["equipe_1"],
                Regional: res.data.informacao["regional"],
                IdCard: res.data.informacao["idCard"],
              },
            });

            setDadosLogin(
              dataSend(res.data.informacao["idCard"])
            );
            
          }
          if (res.data["retorno"] === "coordenador sem equipe") {
            showToast("semEquipe");
          }

          if (res.data["retorno"] === "usuario inativo") {
            showToast("inativo");
            setLoad(false);
          }
        })
        .catch((error: any) => {
          if (error.response.data["retorno"] === "senha incorreta") {
            showToast("senhaErrada");
          }
          if (error.response.data["retorno"] === "usuario inexistente") {
            showToast("email");
          }
          if (error.response.status === 500) {
            showToast("warning");
            setLoad(false);
          }
          setLoad(false);
        });
    },
    [setLoad, showToast, dataSend, setDadosLogin]
  );

  const setDados = useCallback(
    async ({ id }) => {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };

      await api
      api.get(`/csp/representante/cards/consultar?idCard=${id}`)
        .then((res) => {
          if (res.status === 200) {
            setLoad(false);
            const removeItem = (arr: any, refId: any) => {
              return arr.filter(function (i: any) {
                return i.situa_o_arp !== refId;
              });
            };
            const arr = removeItem(res.data["cards"], "inativo");

            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });
          }
        })
        .catch((error) => {
          setLoad(false);
          if (error.response.status === 403) {
            showToast("403");
            setLoad(false);
          }
          if (error.response.status === 404) {
            showToast("404");
            setLoad(false);
          }
          if (error.response.status === 500) {
            showToast("500");
            setLoad(false);
          }
        });
    },
    [setLoad, showToast]
  );

  const checkVersion = useCallback(async () => {
    setLoad(true);
    try {
      const response = await api.get("/csp/versaoapi/consultar/Arp");
      if (response.status === 200) {
        const apiVersion = response.data.versoes?.[0].versao;

        if (apiVersion !== version.version) {
          window.location.reload();
        }
        const versionStorage: any = localStorage.getItem("@ARP-appVersion");
        const parsedVersionStorage = JSON.parse(versionStorage);
        const versionStorageParsed = parsedVersionStorage.versionStorage;

        if (apiVersion !== versionStorageParsed) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }

    setLoad(false);
  }, [setLoad]);

  const handleClickPage = useCallback(
    (e: keyof typeof Label | string) => {
      const Label = {
        default: "Minhas propostas",
        calendario: "Meus compromissos",
        GPCR: "Gerar nova proposta",
        Conteudo: "Área de conteúdos",
        Contato: "Entrar em contato",
        Calculadora: "Simular proposta",
        AnaliseProposta: "Análise de propostas",
      };

      if (e in Label) {
        setHeaderLabel(Label[e as keyof typeof Label]);
      } else {
        setHeaderLabel(Label.default);
      }

      switch (isEditing) {
        case true:
          handleNewActive(e);
          setIsOpenCancel(true);
          break;
        case false:
          handleActive(e);
          setIsOpenUser(false);
          break;
        default:
          //setIsOpenUser(false)
          break;
      }
    },
    [isEditing, handleNewActive, handleActive, setIsOpenCancel, setIsOpenUser]
  );

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <AuthContext.Provider
        value={{
          setDados,
          isLogin,
          signIn,
          checkVersion,
          setIsOpenUser,
          setIsOpenCompromisso,
          setDataUser,
          setIsEditing,
          setIsOpenCancel,
          handleActive,
          handleNewActive,
          setOpenModal,
          setChaveSessao,
          setEmailSessao,
          setOpenModalWpp,
          emailSessao,
          chaveSessao,
          newActive,
          active,
          modalIsOpenCancel,
          isOpenUser,
          isOpenCompromisso,
          isEditing,
          dataUser,
          openModal,
          headerLabel,
          handleClickPage,
          openModalWpp,
        }}
      >
        {children}
      </AuthContext.Provider>
    </>
  );
};

function useAPI(): IAuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}

export { AuthProvider, useAPI };
